import React, {useState, useEffect} from "react";
import Footer from "../components/footer";

import { useLocation, useNavigate } from "react-router-dom";


import styles from "../styles/notification.module.css";

import { Skeleton } from "@mui/material";

import { useMediaQuery } from "react-responsive";

import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';

import ReactGa from "react-ga4";

// Require Editor JS files.
import 'froala-editor/js/froala_editor.pkgd.min.js';

// Require Editor CSS files.
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';

//정렬 플러그인 추가
import "froala-editor/js/plugins/align.min.js"
//색깔 플러그인 추가
import "froala-editor/js/plugins/colors.min.js"
import "froala-editor/css/plugins/colors.min.css"
//draggable 플러그인 추가
import "froala-editor/js/plugins/draggable.min.js"
import "froala-editor/css/plugins/draggable.min.css"
//폰트 사이즈 플러그인 추가
import "froala-editor/js/plugins/font_size.min.js"
//폰트 종류 플러그인 추가
import "froala-editor/js/plugins/font_family.min.js"
//이미지 플러그인 추가
import "froala-editor/js/plugins/image.min.js"
import "froala-editor/css/plugins/image.min.css"
//line height 설정 플러그인 추가
import "froala-editor/js/plugins/line_height.min.js"
//링크 추가 플러그인
import "froala-editor/js/plugins/link.min.js"
//비디오 플러그인 추가
import "froala-editor/js/plugins/video.min.js"
import "froala-editor/css/plugins/video.min.css"
//특수문자 플러그인
import "froala-editor/js/plugins/special_characters.min.js"
import "froala-editor/css/plugins/special_characters.min.css"
//이모티콘
import "froala-editor/js/plugins/emoticons.min.js"
import "froala-editor/css/plugins/emoticons.min.css"
//표 넣기
import "froala-editor/js/plugins/table.min.js"
import "froala-editor/css/plugins/table.min.css"
//class 넣기
import "froala-editor/js/plugins/inline_class.min.js";


const THUMBNAIL_URL = "https://pub-81fe206b05a84c2da16285ce68449232.r2.dev/sunbae/blog/1/thumbnail555.webp";

const BRIEFING_MAP: Record<string, string> = {
    "동탄": "/sunbaebriefing_dongtan",
    "하남": "/sunbaebriefing_hanam",
    "강동": "/sunbaebriefing_gangdong",
    "김포": "/sunbaebriefing_gimpo",
    "센텀": "/sunbaebriefing_centum2",
};


const IntroduceDetail : React.FC<any> = (props) => {

    const location = useLocation();
    const navigate = useNavigate();
    const query = new URLSearchParams(location.search);
    const [data, setData] = useState<any>();
    const [dateString, setDateString] = useState<any>("");

    const isPC = useMediaQuery({query : '(min-width : 1150px)'});

    const locationQuery = query.get("location") || "";
    const briefingPath = BRIEFING_MAP[locationQuery];
    const ctaPath = briefingPath || "/registerWaiting2026";
    const ctaText = briefingPath ? "1분 설명회 신청" : "1분 대기 신청";

    useEffect(() => {
        ReactGa.send({
            hitType: "pageview",
            page_title: "introducedetail"
        });
    }, []);

    useEffect(()=>{
        window.scrollTo(0,0);
    })

    useEffect(()=>{
        const id = 479;

        ReactGa.event({
            category: "introduceDetailView",
            action: "introduceDetailView",
            value: id
        });

        const locationParam = query.get("location") || "수능선배";

        fetch(`https://suneungsunbae.com/api/text/notificationdetail?id=${id}`, {
            method : "get"
        }).then((response : any)=>{
            response.json()
            .then((result : any) => {

                if(result.data && result.data.body){
                    result.data.body = result.data.body.replaceAll("${지점}", locationParam);
                    result.data.body = result.data.body.replaceAll("opacity: 0.65", "display: none");

                    if(isPC){
                        result.data.body = result.data.body.replaceAll("font-size: 16", "font-size: 18");
                        result.data.body = result.data.body.replaceAll("width: 500px", "width: 700px");
                        result.data.body = result.data.body.replaceAll("width: 400px", "width: 560px");
                        result.data.body = result.data.body.replaceAll("width: 300px", "width: 420px");
                    }
                }

                setData(result.data);
                const d = result.data;
                const date = new Date(d.createdAt);
                const newDateString = `${date.getFullYear()}.${date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1}.${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}`;
                setDateString(newDateString);
            })
        })

    }, [])

    useEffect(()=>{
        const linkElement = document.createElement("link");
        linkElement.setAttribute("rel", "stylesheet");
        linkElement.setAttribute("type", "text/css");
        linkElement.setAttribute("href", "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
        document.head.appendChild(linkElement);
    })


    return (
        <>
            <div style={{paddingBottom: "100px"}}>
                <div className={`${styles.notificationBox} ${styles.forDescription} ${styles.forStoryBox}`} style={{marginTop: isPC ? "60px" : "20px"}}>
                    <div className={`${styles.storyHeader} ${styles.forDescription}`}>
                        초호화 멘토진 121명과<br />함께하는 대치동 1등<br />독학재수학원
                    </div>
                    <div className={styles.storyHeaderDescription}>
                            <div className={styles.storyDate}>
                                2026.5.23 ㆍ by 수능선배
                            </div>
                    </div>

                    <div className={styles.storyMainImgDiv}>
                        <img className={styles.mainImg} src={THUMBNAIL_URL} alt="" />
                    </div>

                    <div className={styles.notificationBodyHtmlDiv}>
                        {
                            data ?
                            <FroalaEditorView
                            model={data.body}
                            />
                            :
                            <Skeleton variant="rectangular" sx={{width : "100%", height : "300px"}} />
                        }
                    </div>
                </div>
            </div>

            <Footer />

            <button
                onClick={() => navigate(ctaPath)}
                className={styles.introCtaButton}
            >
                {ctaText}
            </button>
        </>

    );
}

export default IntroduceDetail;
